import { render } from "./HeroiconsSolidViewGridAdd.vue?vue&type=template&id=189d07ba"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidViewGridAdd.vue"]])

export default __exports__